import { reduxServices } from '../reducers/reduxServices'

export function currentPageData<T>(
  tableData: T[],
  currentPage: number,
  pageSize: number,
): T[] {
  if (tableData?.length > 0) {
    const firstPageIndex = (currentPage - 1) * pageSize
    const lastPageIndex = firstPageIndex + pageSize
    return tableData.slice(firstPageIndex, lastPageIndex)
  }

  return [] as T[]
}

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function registerRelatedRoute() {
  return reduxServices.app.actions.setReRouteLocation(window.location.pathname)
}

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function registerRelatedRouteWithParam(param: string) {
  return reduxServices.app.actions.setReRouteLocation(
    window.location.pathname?.replaceAll(`/${param}`, ''),
  )
}

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function fromRelatedRouteBooleanState() {
  return reduxServices.app.actions.setFromRelatedRoute(true)
}
